import { MonthPicker as GammaMonthPicker } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type MonthPickerProps = React.ComponentProps<typeof GammaMonthPicker>

type Props = Omit<
  MonthPickerProps,
  'selectValue' | 'missingLabel' | 'getDate' | 'getValue' | 'onMonthClick'
> & {
  missingLabel?: string
}

const MonthPicker = ({ missingLabel, ...props }: Props) => {
  const onMonthClick =
    (onChange: ((date: string) => void) | undefined) => (date: moment.Moment) => {
      onChange && onChange(dateToString(date, 'ui'))
    }

  const getDate = (value: string | undefined) => {
    if (!value) return moment().startOf('month')

    return stringToDate(value, 'ui')
  }

  const getValue = (value: string | undefined, placeholder: string | undefined) => {
    if (!value && placeholder) {
      return placeholder
    }

    const date = getDate(value)

    return [date.year(), date.format('M')].join('/')
  }

  return (
    <GammaMonthPicker
      {...props}
      missingLabel={missingLabel ?? i18n.t('common.missing_field')}
      selectValue={i18n.t('common.select')}
      getDate={getDate}
      getValue={getValue}
      onMonthClick={onMonthClick}
    />
  )
}

export default MonthPicker
